import { html } from "lit-html";
import I18nService from "Services/I18nService";

import { DVAGCInstagramPost } from "./dvagc-m-instagram-post";

export interface InstagramPostTemplateParameter {
  component: DVAGCInstagramPost;
}

const getPosterImage = () => {
  return html` <dvag-e-icon
    class="dvag-e-icon dvagc-m-instagram-post__poster-image"
    icon-id="dvagc-social-placeholder"
  ></dvag-e-icon>`;
};

const renderConsentOverlay = async (args: InstagramPostTemplateParameter) => {
  if (args.component.hasConsent === true) return "";
  return html`
    <div class="dvagc-m-consent-blocking-overlay">
      <p class="dvagc-m-consent-blocking-overlay__text">
        ${(await I18nService.getValue("dvag.dvag-career.instagram.consentText")) || ""}
      </p>

      <button
        class="dvag-e-button dvag-e-button--small dvagc-m-consent-blocking-overlay__btn"
        @click=${() => args.component.acceptConsent()}
      >
        <div class="dvag-e-button__background"></div>
        <span class="dvag-e-button__label">
          ${(await I18nService.getValue("dvag.dvag-career.instagram.buttonLabel")) || ""}
        </span>
      </button>
    </div>
  `;
};

const renderInstagramFrame = (args: InstagramPostTemplateParameter) => {
  if (args.component.hasConsent !== true) return "";

  return html`
    <iframe
      class="dvagc-m-instagram-post__iframe"
      height="${args.component.instagramHeight}"
      src="https://www.instagram.com/p/${args.component.instagramPostId}/embed/captioned/"
      allowtransparency="true"
      allowfullscreen="true"
      frameborder="0"
      scrolling="no"
      aria-label="Instagram Post"
    >
    </iframe>
  `;
};

export const instagramPostTemplate = async (args: InstagramPostTemplateParameter) => {
  return html`
    <div class="dvagc-m-instagram-post__iframe-wrapper">
      ${getPosterImage()} ${renderInstagramFrame(args)} ${await renderConsentOverlay(args)}
    </div>
  `;
};
